import React from 'react'
import SEO from '../components/common/SEO'
import ProjectsBanner from '../components/projects/ProjectsBanner'
import ProjectsGrid from '../components/projects/ProjectsGrid'
import CTASection from '../components/common/CTASection'

const Projects = () => {
  return (
    <>
      <SEO
        title="Our Projects | AZ Construction Indore"
        description="Explore the portfolio of AZ Construction featuring luxury residential, commercial, and infrastructure projects successfully delivered in Indore and across Madhya Pradesh."
        url="https://azconstruction.com/projects"
      />
      <ProjectsBanner />
      <ProjectsGrid />
      <CTASection />
    </>
  )
}

export default Projects
